import { render, staticRenderFns } from "./CoberturasCentrosMunicipales.vue?vue&type=template&id=36326b94&lang=pug&"
import script from "./CoberturasCentrosMunicipales.vue?vue&type=script&lang=js&"
export * from "./CoberturasCentrosMunicipales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports